import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { iconFob, iconFobCanton } from '../Constants/ConstantsOptics';
import useZoomLevel from './useZoomLevel'; 

const MarkersEditingFob = ({ markers, selectedRankFob, removeMarker, type }) => {
 
  const selectedIcon = selectedRankFob === '1' || selectedRankFob === '2' ? iconFob : iconFobCanton;
  const zoomLevel = useZoomLevel();

  if (zoomLevel <= 15) {
    return null;
  }

  return (  
  <>
    {markers.map((marker, index) => (
      <Marker
        key={index}
        position={[marker.lat, marker.lng]}
        icon={selectedIcon}
      >
        <Popup autoClose={false} className="custom-popup">
          <div>
            <label style={{ color: '#555555', fontSize: '16px' }}>{type}</label>
            <hr className="horizontalLinePopup" />
            <button className="popupButtonDelete" onClick={(e) => { e.stopPropagation(); removeMarker(index); }}>Удалить маркер</button>
          </div>
        </Popup>
      </Marker>
    ))}
  </>
  );
}
export default MarkersEditingFob;
